import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/features/my-profile/layout/content/page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Menu"] */ "/vercel/path0/src/features/my-profile/layout/sidebar/bottom/Menu.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/features/my-profile/layout/sidebar/top/page.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/features/my-profile/layout/title/page.tsx");
